var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('company-toba-additive-form',{ref:"form",attrs:{"loading":_vm.loading},on:{"deleteToba":_vm.confirmDeleteToba},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }